import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const PageList = (props) => {
  const [characters, updateCharacters] = useState([]);
  const seasonlabel = useFormInput("");
  const seasonId = useFormInput("");

  const reorderArray = (items) => {
    const newItems = items.map((item, index) => {
      item.order = index + 1;
      return item;
    });
    updateCharacters(newItems);
    const newArr = newItems;
    props.onChange(newArr);
  };

  const newContainer = (event) => {
    event.preventDefault();

    const newer = {
      value: seasonId.value,
      label: seasonlabel.value,
      order: characters.length + 1,
      id: seasonId.value + characters.length + 1,
    };
    updateCharacters([...characters, newer]);
    const newArray = [...characters, newer];
    props.onChange(newArray);
  };

  useEffect(() => {
    const getDetails = () => {
      const opt = props.listData.map((item) => ({
        value: item.itemid,
        label: item.itemRef,
        order: item.itemOrder,
        id: item.itemid,
      }));

      updateCharacters(opt);
    };

    getDetails();
  }, [props.listData]);

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(characters);
    const [reorderedItem] = items.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, reorderedItem);
    reorderArray(items);
  };

  const handleRemove = (event, index) => {
    const removeId = index;
    event.preventDefault();
    const items = Array.from(characters);
    items.splice(index, 1);

    reorderArray(items);
  };

  return (
    <div className="row mb-2 mt-2">
      <div className="col-sm-12">
        <div className="form-group">
          <div className="row">
            {props.dir === "rtl" && (
              <div className="col-md-2">
                <button
                  type="button"
                  className="btn btn-light btn-block"
                  style={{ width: "100px", marginTop: "8px", height: "40px" }}
                  onClick={newContainer}
                >
                  Add
                </button>
              </div>
            )}
            <div className="col-md-5">
              <label
                className={props.dir === "rtl" ? "float-right" : "float-left"}
              >
                List Name
              </label>
              <input
                type="text"
                dir={props.dir}
                name="appseasonName"
                className="form-control inside-form"
                placeholder="List Name ..."
                {...seasonlabel}
                autoComplete="off"
              />
            </div>

            <div className="col-md-5">
              <label
                className={props.dir === "rtl" ? "float-right" : "float-left"}
              >
                List Playlist
              </label>
              <input
                type="text"
                dir={props.dir}
                name="appseasonid"
                className="form-control inside-form"
                placeholder="List Playlist ID ..."
                {...seasonId}
                autoComplete="off"
              />
            </div>
            {!(props.dir === "rtl") && (
              <div className="col-md-2">
                <button
                  type="button"
                  className="btn btn-light btn-block"
                  style={{ width: "100px", marginTop: "8px", height: "40px" }}
                  onClick={newContainer}
                >
                  Add
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-12">
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId={"characters"}>
            {(provided) => (
              <ul
                className="products-list product-list-in-card pl-2 pr-2"
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={{ maxHeight: "350px", overflowY: "scroll" }}
              >
                {characters.map((item, index) => (
                  <Draggable
                    key={item.id}
                    draggableId={"item" + item.id}
                    index={index}
                  >
                    {(provided) => (
                      <li
                        className="item"
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <div className="product-info">
                          <a href="#!" className="product-title">
                            {item.label}
                            <span className="badge badge-warning float-left">
                              {item.order}
                            </span>
                          </a>

                          <div
                            className="text-right"
                            style={{ display: "inline", float: "right" }}
                          >
                            <a
                              className="btn btn-light btn-sm"
                              href="#!"
                              onClick={(event) => handleRemove(event, index)}
                            >
                              <i className="fas fa-trash"></i>
                            </a>
                          </div>
                          <span
                            className="product-description"
                            style={{ marginLeft: "55px" }}
                          >
                            {item.value}
                          </span>
                        </div>
                      </li>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
};

const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (e) => {
    setValue(e.target.value);
  };
  return {
    value,
    onChange: handleChange,
  };
};

export default PageList;
